module.exports = __webpack_public_path__ + "img/psychic.60982f05.svg";